import { render, staticRenderFns } from "./trade-menu.svg.vue?vue&type=template&id=06c11ea6&"
import script from "./trade-menu.svg.vue?vue&type=script&lang=js&"
export * from "./trade-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports